<div *ngIf="prikaziStranicu" class="container-fluid">
  <h2 class="content-block">DOKUMENTI</h2>

  <div class="content-block dnevniPlanWrapper">
    <dx-button
      type="button"
      class="back-button-onRights"
      (click)="backButtonClicked()"
    >
      <b>Nazad</b>
    </dx-button>

    <div class="selectDates">
      <div class="odabirDatuma">
        <label>Datum od:</label>
        <dx-date-box
          [(value)]="datumOd"
          [(max)]="datumDo"
          pickerType="calendar"
          displayFormat='dd.MM.yyyy.'
          width="200"
          (onValueChanged)="onValueChangedDatumOd($event)"
        >
        </dx-date-box>
      </div>

      <div class="odabirDatuma">
        <label>Datum do:</label>
        <dx-date-box
          [(value)]="datumDo"
          [(min)]="datumOd"
          pickerType="calendar"
          displayFormat='dd.MM.yyyy.'
          width="200"
          (onValueChanged)="onValueChangedDatumDo($event)"
        >
        </dx-date-box>
      </div>

      <!-- OVO JE ODABIR POSLOVNICE ALI RADI CSS-a SE KLASA ZOVE ODABIR DATUMA -->
      <div class="odabirDatuma">
        <label [style]="{ 'margin-left': '30px' }">Poslovnice:</label>
        <dx-select-box
          valueExpr="po_sifra"
          displayExpr="sifrainaziv"
          [value]="poslovnice[0].po_sifra"
          [items]="poslovnice"
          [searchEnabled]="true"
          [searchExpr]="['po_naziv', 'po_sifra']"
          width="400"
          (onValueChanged)="promjenaPoslovnice($event)"
          [style]="{ 'margin-left': '30px' }"
        >
        </dx-select-box>
      </div>

      <div class="odabirDatuma">
        <dx-button
          class="btn_trazi"
          [disabled]="disableGumb"
          stylingMode="contained"
          text="Prikaži"
          type="success"
          [width]="120"
          (onClick)="pretrazi()">
        </dx-button>
      </div>
    </div>

    <div class="customTable dnevniPlan">
      <dx-data-grid
        [dataSource]="dokumenti"
        [wordWrapEnabled]="true"
        noDataText="{{ poruka }}"
        [showBorders]="false"
        [showColumnLines]="true"
        (onToolbarPreparing)="onToolbarPreparing($event)"
        (onCellPrepared)="onCellPrepared($event)"
      >
        <div *dxTemplate="let data of 'naslovTablice'" class="grid-wrapper">
          <div class="naslov">
            <h2 class="mb-0" style="padding-right: 30px">Dokumenti</h2>
            <p class="mt-0">Kliknite na dokument za prikaz detalja</p>
          </div>
        </div>

        <!-- <div *dxTemplate="let data of 'odabirPoslovnice'">
          <div class="selectDropdown">
            <span>Poslovnice</span>
            <dx-select-box
              [disabled]="false"
              [items]="poslovnice"
              valueExpr="po_sifra"
              displayExpr="po_naziv"
              [width]="250"
              (onValueChanged)="promjenaPoslovnice($event)"
            >
            </dx-select-box>
          </div>
        </div> -->

        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-header-filter [visible]="true"></dxo-header-filter>

        <!-- <dxo-scrolling
        columnRenderingMode="virtual"
        [showScrollbar]="'always'"
      ></dxo-scrolling> -->

        <dxo-search-panel
          [visible]="true"
          [width]="210"
          placeholder="Pretraži..."
        >
        </dxo-search-panel>

        <dxo-paging [enabled]="true" [pageSize]="15"></dxo-paging>

        <dxo-pager
          [showPageSizeSelector]="true"
          [allowedPageSizes]="[20, 30, 40]"
          [showInfo]="true"
        >
        </dxo-pager>

        <dxi-column
          dataField="pz_broj"
          caption="Broj dokumenta"
          alignment="right"
          width="120"
          [calculateSortValue]="calculateSortValue"
        ></dxi-column>

        <dxi-column
          dataField="idveznidokumentprikaz"
          caption="Vezni dokument"
          alignment="left"
          width="fit-content"
        ></dxi-column>

        <dxi-column
          dataField="DV_NAZIV"
          caption="Vrsta dokumenta"
          alignment="left"
          width="fit-content"
        ></dxi-column>

        <dxi-column
          dataField="pz_datum"
          dataType="date"
          caption="Datum dokumenta"
          width="fit-content"
          alignment="left"
        ></dxi-column>

        <dxi-column
          dataField="pz_danisat"
          dataType="date"
          caption="Datum i vrijeme izrade dokumenta"
          width="fit-content"
          alignment="left"
        ></dxi-column>

        <dxi-column
          dataField="pz_iznos"
          caption="Iznos"
          alignment="right"
          width="fit-content"><dxo-format type="fixedPoint" [precision]="2"></dxo-format>
        </dxi-column>

        <dxi-column
          dataField="pz_porez"
          caption="Iznos poreza"
          alignment="right"
          width="fit-content">
          <dxo-format type="fixedPoint" [precision]="2"></dxo-format>
        </dxi-column>

        <dxi-column
          dataField="po_sifra"
          caption="Skladište"
          alignment="right"
          width="160"
        ></dxi-column>

        <dxi-column
          dataField="po_naziv"
          caption="Poslovnica"
          width="fit-content"
          alignment="left"
        ></dxi-column>

        <dxi-column
          dataField="pz_status"
          caption="Status"
          width="120"
          alignment="center"
        ></dxi-column>

        <!-- <dxi-column alignment="left"></dxi-column> -->

        <dxi-column cellTemplate="pdfFile" width="70">
          <div *dxTemplate="let data of 'pdfFile'">
            <div *ngIf="data.data.DV_SIFRA === 'DOSTAV'"><!-- Dostavnica -->
              <dx-button
                icon="pdffile"
                (onClick)="pdfDostavnica(data)"
                [disabled]="pravaZaTrenutniPogled != 2">
              </dx-button>
            </div>

            <div *ngIf="data.data.DV_SIFRA === 'OTPREM'"><!-- OTPREMNICA -->
              <dx-button
                icon="pdffile"
                (onClick)="pdfOtpremnica(data)"
                [disabled]="pravaZaTrenutniPogled != 2">
              </dx-button>
            </div>

            <div *ngIf="data.data.DV_SIFRA === 'IZDSIR' && data.data.pz_status === 'Z'"><!-- Izdatnica sirovina -->
              <dx-button
                icon="pdffile"
                (onClick)="pdfIzdatnicaSirovinaZavrseno(data)"
                [disabled]="pravaZaTrenutniPogled != 2">
              </dx-button>
            </div>

            <div *ngIf="data.data.DV_SIFRA === 'IZDSIR' && data.data.pz_status === 'I'"><!-- Izdatnica sirovina -->
              <dx-button
                icon="pdffile"
                (onClick)="pdfIzdatnicaSirovinaIzradi(data)"
                [disabled]="pravaZaTrenutniPogled != 2">
              </dx-button>
            </div>

            <div *ngIf="data.data.DV_SIFRA === 'IZDPOT'"><!-- izdatnica potrošnog materijala -->
              <dx-button
                icon="pdffile"
                (onClick)="pdfIzdatnicaPotrosnogMaterijala(data)"
                [disabled]="pravaZaTrenutniPogled != 2">
              </dx-button>
            </div>

          </div>
        </dxi-column>

        <dxo-summary *ngIf="dokumenti.length > 0">
          <dxi-total-item showInColumn="pz_danisat" alignment="right" displayFormat="UKUPNO: " ></dxi-total-item>
          <dxi-total-item column="pz_iznos" summaryType="sum" name="ukupnoIznos" alignment="right" displayFormat="{0} €" [valueFormat]="{ type: 'fixedPoint', precision: 2 }"></dxi-total-item>
          <dxi-total-item column="pz_porez" summaryType="sum" name="ukupnoPorez" alignment="right" displayFormat="{0} €" [valueFormat]="{ type: 'fixedPoint', precision: 2 }"></dxi-total-item>
        </dxo-summary>

      </dx-data-grid>
    </div>
  </div>
</div>
